import { isSameId } from "../../helpers";
export default function (store, { id }) {
    store.in.exec("unselect-card", { id });
    const state = store.getState();
    const cardIndex = state.cards.findIndex(c => isSameId(c.id, id));
    const card = state.cards[cardIndex];
    const before = state.cards[cardIndex + 1]?.id;
    const cards = state.cards.filter(card => !isSameId(card.id, id));
    store.setState({ cards });
    return () => {
        store.in.exec("add-card", {
            columnId: card[state.columnKey],
            before,
            card,
            $meta: {
                skipHistory: true,
                restore: id,
            },
        });
    };
}
//# sourceMappingURL=delete.js.map